"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (date) {
    return Math.floor(date.getTime() / 1000);
};


//////////////////
// WEBPACK FOOTER
// ./~/binary-utils/lib/date/dateToEpoch.js
// module id = 54
// module chunks = 0